import NewsletterSectionUnsubscribe from './NewsletterSectionUnsubscribe'

const NewsletterSectionEnd = ({
    stylesData, 
    cinemaData, 
    translation
}) => {

    return (
        <NewsletterSectionUnsubscribe
            stylesData={stylesData}
            cinemaData={cinemaData}
            translation={translation}
        />
    )
}

export default NewsletterSectionEnd